import { render, staticRenderFns } from "./ListEditor.vue?vue&type=template&id=5143c79c&scoped=true&"
import script from "./ListEditor.vue?vue&type=script&lang=js&"
export * from "./ListEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5143c79c",
  null
  
)

export default component.exports